<template>
	<page>
		<div>
			<game-more-settings-modal
				v-model="moreSettingsDialog"
				@close="moreSettingsDialog = false"
				@save="updateJson"
			/>
			<v-btn
				v-if="false"
				slot="activator"
				@click="moreSettingsClicked"
				color="#00a9a3"
				dark
			>
				<v-icon>add</v-icon>
				ערוך הגדרות נוספות
			</v-btn>
		</div>
		<div :class="['resp-container', displayView, single, iframeGameVersionClass]">
			<iframe
				id="edit-iframe"
				class="resp-iframe"
				ref="iframe"
				:src="src"
				allowfullscreen
				scrolling="no"
			></iframe>
		</div>
		<relation-media-modal
			v-model="mediaDialog"
			v-if="mediaDialog"
			:typeFilter="typeFilter"
			@close="mediaDialog = false"
			@mediaSelected="mediaSelected"
		/>
		<type-help-dialog v-model="showTypeHelp" v-if="showTypeHelp" :src="game.type.help_link" @close="showTypeHelp = false"/>
	</page>
</template>

<script>
import TypeHelpDialog from "../types/TypeHelpDialog";
import { types as GameTypes } from "../../store/modules/Game.module";
import RelationMediaModal from "src/view/media/RelationMediaModal";
import GameMoreSettingsModal from "dev/view/games/GameMoreSettingsModal";

export default {
	name: "game-edit-view",
	props: ["displayView", "single"],
	components: {
		GameMoreSettingsModal,
		RelationMediaModal,
		TypeHelpDialog
	},
	data() {
		return {
			json: {},
			mediaDialog: false,
			mediaDialogKey: 0,
			moreSettingsDialog: false,
			typeFilter: [],
			iframeReadycounter: 0,
			updateJsoncounter: 0,
			iframeReady: false,
			inProgress: false,
			overrideSrc: "",
			showTypeHelp: false
		};
	},
	computed: {
		game() {
			return this.$store.getters.game;
		},
		canSendJson() {
			return this.game;
		},
		src() {
			let src = "";
			if(this.game.type && this.game.type.edit_iframe_override != null && this.game.type.edit_iframe_override != 'null') {
				src = this.game.type.edit_iframe_override;
			} else {
				src = "https://pashframe.closeapp.co.il/games/indexEditModeZim2.html?edit=true";
			}
      src += "&hide_ani=true"
			if (this.displayView === "mobile") src += "&mobileView=true";
			return src;
		},
		iframeGameVersionClass() {
			if(this.src.includes('/pash/')) {
				return 'v1-game';
			} else {
				return 'v2-game';
			}
		}
	},

	methods: {
		moreSettingsClicked() {
			this.moreSettingsDialog = true;
			this.getLastJson();
		},
		getLastJson() {
			window.popup = this.$refs.iframe;
			window.popup.contentWindow.postMessage(
				{
					action: "lastJson"
				},
				"*"
			);
		},
		receiveMessage(event) {
			// if (event.origin !== "https://closeapp.co.il")
			// 	return;
			if (event.data.action === "iframeReady") {
				this.iframeReady = true;
				if (this.canSendJson) {
					this.sendJson(event.source);
				}
			} else if (event.data.action === "updateJson")
				this.updateJson(event.data);
			else if (event.data.action === "openMediaSelect")
				this.openMedia(event.data.fileFilter);
			else if (event.data.action === "requestGameID") {
				this.sendGameId();
			}
			else if(event.data.action === "showHelp") {
				this.showTypeHelp = true;
			}
			else if(event.data.action === "startGame") {
        const url = this.game.link;
        window.open(url, "_blank");
			}
			this.iframeReadycounter++;
		},
		sendJson() {
			window.popup = this.$refs.iframe;
			if (window.popup)
				window.popup.contentWindow.postMessage(
					{
						action: "getJson",
						json: JSON.parse(this.game.json),
						language: this.$i18n.locale
					},
					"*"
				);
		},
		sendGameId() {
			window.popup = this.$refs.iframe;
			if (window.popup)
				window.popup.contentWindow.postMessage(
					{
						action: "getGameID",
						gameId: this.game.id
					},
					"*"
				);
		},
		updateJson(data) {
			if (0 === this.updateJsoncounter++) {
				this.json = data.json;
				let game = Object.assign({}, this.game);
				game.json = JSON.stringify(this.json);
				this.$store.dispatch(GameTypes.SAVE, game).then(() => {
					this.sendJsonAfterSave(data);
					this.$emit("jsonChanged");
					if (data.refreshPage) this.refreshIframe();
					this.updateJsoncounter = 0;
				});
			}
		},
		refreshIframe() {
			this.$emit("updateIframe");
		},
		sendJsonAfterSave() {
			window.popup = this.$refs.iframe;
			if (window.popup)
				window.popup.contentWindow.postMessage(
					{
						action: "getJsonAfterSave",
						json: JSON.parse(this.game.json)
					},
					"*"
				);
		},
		openMedia(typeFilter) {
			this.typeFilter = typeFilter;
			this.mediaDialog = true;
		},
		mediaSelected(value) {
			let popup = this.$refs.iframe;
			popup.contentWindow.postMessage(
				{
					action: "haveMedia",
					mediaSrc: value.link
				},
				"*"
			);
		},
		postIframe() {
			let iframe = this.$refs.iframe;
			if (iframe) {
				iframe.onload = () => {
					this.sendJson();
				};
			}
		}
	},
	created() {
		this.iframeReadycounter = 0;
		this.updateJsoncounter = 0;
		window.addEventListener("message", this.receiveMessage);
	},
	watch: {
		game: {
			immediate: true,
			handler() {
				if (this.canSendJson) {
					if (this.iframeReady) this.sendJson();
					// else
					// 	this.postIframe();
				}
			}
		}
	},
	destroyed() {
		window.removeEventListener("message", this.receiveMessage);
	}
};
</script>

<style scoped>
.resp-iframe {
  border: 0;
  display: block;
  width:100%;
  aspect-ratio: 43 / 27;
  max-height: 70vh;
}

.v2-game .resp-iframe {
	aspect-ratio: 1720/1180;
}

.mobile .resp-iframe {
	aspect-ratio: 15 / 8 !important;
}

#inspire
  > div
  > div
  > main
  > div
  > div
  > div
  > div
  > div
  > div.layout.row.wrap
  > div
  > div
  > div:nth-child(2)
  > div
  > div:nth-child(1)
  > button {
  position: absolute;
  left: 2vw;
  top: 3.5vh;
}
</style>
